import React, {useRef, useEffect} from 'react';
import {Box} from '@customink/pigment-react';
import mobilePromoImage from 'images/hardgoods-promo/hardgoods-promo-mobile.png';
import desktopPromoImage from 'images/hardgoods-promo/hardgoods-promo-desktop.png';
import {hardgoodsPromoBannerAnalytics} from '../utils/ab_tests/hardgoodsPromoTest';
import config from '../config';

const imagePath = (image) => {
  return `${config.assets.imagePath}${image}`;
};

export const HardgoodsPromoBanner = ({
  analyticsAttributes,
  variant = 'desktop'
}) => {
  const analyticsFired = useRef(false);

  useEffect(() => {
    if (!analyticsFired.current) {
      hardgoodsPromoBannerAnalytics(
        analyticsAttributes,
        variant === 'desktop' ? 'PLP Banner' : 'PLP Mobile Banner'
      );
      analyticsFired.current = true;
    }
  }, []);

  const image =
    variant === 'mobile'
      ? imagePath(mobilePromoImage)
      : imagePath(desktopPromoImage);

  return (
    <Box sx={{width: '100%'}}>
      <img src={image} alt="Hardgoods Promo" width="100%" aspectRatio="auto" />
    </Box>
  );
};
